import defaultSettings from '@/settings';
var showSettings = defaultSettings.showSettings,
  fixedHeader = defaultSettings.fixedHeader,
  sidebarLogo = defaultSettings.sidebarLogo,
  tagsView = defaultSettings.tagsView,
  dateFormat = defaultSettings.dateFormat,
  timeEntryRequired = defaultSettings.timeEntryRequired;
var state = {
  showSettings: showSettings,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  tagsView: tagsView,
  dateFormat: dateFormat,
  preferences: {
    task: {
      timeEntryRequired: timeEntryRequired
    }
  }
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  }
};
var actions = {
  changeSetting: function changeSetting(_ref2, data) {
    var commit = _ref2.commit;
    commit('CHANGE_SETTING', data);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};